import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentStack20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconDocumentStack20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 16h.5a2.5 2.5 0 0 0 2.5-2.5V6.416a2 2 0 0 0-.552-1.38L13.19 1.62A2 2 0 0 0 11.743 1H8.5A2.5 2.5 0 0 0 6 3.5V4h-.5A2.5 2.5 0 0 0 3 6.5v10A2.5 2.5 0 0 0 5.5 19h6a2.5 2.5 0 0 0 2.5-2.5zm0-1.5h.5a1 1 0 0 0 1-1V7.673h-2.398l.346.363A2 2 0 0 1 14 9.416zm-3.173-9.213V2.5H8.5a1 1 0 0 0-1 1V4h1.243a2 2 0 0 1 1.448.62zm4.61.886a.5.5 0 0 0-.075-.102l-3.035-3.184v3.286zM5.5 17.5h6a1 1 0 0 0 1-1v-5.827H7.827V5.5H5.5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1m6.862-8.429q.045.046.075.102h-3.11V5.887z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentStack20);
